export default __webpack_public_path__ + "static/media/mn_download_m.86622efe.png";